module.exports = __webpack_public_path__ + "img/diy-QiWzKsVi.4d942e08.svg";